import React, { Component } from "react";
import NavBar from "../../Components/NavBar/NavBar";
import AuthCheck from "../../Components/Utils/AuthCheck";
import Loader from "react-loader-spinner";
import Modal from "react-modal";
import { apiUrl } from "../../Components/Utils/Constants";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

export default class Department extends Component {
  constructor(props) {
    super(props);
    this.state = {
      departments: [],
      loading: true,
      isOpen: false,
      departmentField: "",
    };
  }

  // const [modalIsOpen, setIsOpen] = React.useState(false);

  openModal = () => {
    this.setState({
      isOpen: true,
    });
  };

  afterOpenModal = () => {};

  closeModal = () => {
    this.setState({
      isOpen: false,
    });
  };

  componentDidMount() {
    AuthCheck(this.props);
    this.getDepartments();
  }

  getDepartments = () => {
    fetch(`${apiUrl}/admin/getdepartments`)
      .then((response) => response.json())
      .then((response) => {
        this.setState({
          departments: response,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
      });
  };

  onSearchChange = (event) => {
    this.setState({
      departmentField: event.target.value,
    });
  };

  saveDepartment = () => {
    this.setState({
      loading: true,
    });
    fetch("https://bego-consult-api.herokuapp.com/admin/createdepartment", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        department: this.state.departmentField,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.statusCode === 200) {
          this.setState({
            loading: true,
            isOpen: false,
          });
        } else {
          this.setState({
            loading: true,
            isOpen: false,
          });
        }
        this.getDepartments();
      })
      .catch((err) => {
        this.setState({
          loading: true,
          isOpen: false,
        });
      });
  };

  deleteDepartment = (departmentId) => {
    fetch("https://bego-consult-api.herokuapp.com/admin/deletedepartment", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: departmentId,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.statusCode === 200) {
          this.setState({
            loading: true,
          });
        } else {
          this.setState({
            loading: true,
          });
        }
        this.getDepartments();
      })
      .catch((err) => {
        this.setState({
          loading: true,
        });
      });
  };

  render() {
    document.title = "Xtendliving | Admin | Departments";
    const { loading, departments, isOpen } = this.state;

    const tableRow = departments.length ? (
      departments.map((department, index) => {
        return (
          <tr key={index + 1}>
            <td>{index + 1}</td>
            <td>{department.department}</td>
            <td>
              <button key={1} className="btn black">
                VIEW
              </button>
            </td>
            <td>
              <button
                key={2}
                className="btn"
                className="btn"
                style={{ backgroundColor: "red" }}
                onClick={() => this.deleteDepartment(department.id)}
              >
                Delete
              </button>
            </td>
          </tr>
        );
      })
    ) : (
      <tr className="center" colSpan="6">
        <td>No Department Found</td>
      </tr>
    );

    const table = (
      <table className="responsive-table highlight">
        <thead>
          <tr>
            <th>S/N</th>
            <th>Department</th>
            <th></th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          {tableRow}
          <tr className="center" colSpan="6">
            <td>
              <button
                onClick={this.openModal}
                className="btn"
                style={{ backgroundColor: "black" }}
              >
                Add New Department
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    );

    return (
      <div>
        <NavBar loggedIn={true} />
        <div className="container">
          <h4>All Departments</h4>
          {loading ? (
            <Loader type="ThreeDots" color="#000000" height={50} width={50} />
          ) : (
            table
          )}
        </div>
        <Modal
          isOpen={isOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          {/*<div className="container">
              <div className="center">
                <h4>Add Department</h4>
              </div>
            </div>*/}
          <div className="container">
            <div className="center">
              <h6>Add new Department</h6>
              <div className="input-field col s6">
                <input
                  id="input_text"
                  type="text"
                  data-length="10"
                  onInput={this.onSearchChange}
                />
                <label htmlFor="input_text">Enter Department</label>
                <div className="section">
                  <div className="row">
                    <div className="col s12 m6">
                      <div className="icon-block">
                        {loading ? (
                          <Loader
                            type="Circles"
                            color="#000000"
                            height={50}
                            width={50}
                          />
                        ) : (
                          <button
                            onClick={this.saveDepartment}
                            className="btn black"
                          >
                            Save
                          </button>
                        )}
                      </div>
                    </div>

                    <div className="col s12 m6">
                      <div className="icon-block">
                        <button
                          onClick={this.closeModal}
                          className="btn"
                          style={{ backgroundColor: "red" }}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
